import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import ItemsAll from "../Market/ItemsAll";
import MyItems from "../Market/MyItems";
import Basket from "../Market/Basket";

import "../Market/style.scss";

export default function MarketTab({ disabled = false, initialSubTab = "1" }) {
  const { t } = useTranslation();
  const [activeSubTab, setActiveSubTab] = useState(initialSubTab);

  if (disabled) {
    return (
      <div className="sales-and-services__shop-placeholder">
        <p className="sales-and-services__shop-placeholder-title">
          {t("SellingCart.Label")}
        </p>
        <p className="sales-and-services__shop-placeholder-text">
          {t("SalesAndServices.Shop.DisabledMessage")}
        </p>
      </div>
    );
  }

  return (
    <div className="sales-and-services__shop-content">
      <Tabs
        activeKey={activeSubTab}
        transition={false}
        className="panel_tab sales-and-services__shop-tabs"
        onSelect={setActiveSubTab}
      >
        <Tab
          eventKey="1"
          className="panel_tab_item"
          title={t("Organizational.MySellingBasket.All.Items.Tab")}
        />
        <Tab
          eventKey="2"
          className="panel_tab_item"
          title={t("Organizational.MySellingBasket.Tab")}
        />
        <Tab
          eventKey="3"
          className="panel_tab_item"
          title={t("Organizational.SellingBasket.Tab")}
        />
      </Tabs>
      <div className="sales-and-services__shop-panel">
        {activeSubTab === "1" && <ItemsAll />}
        {activeSubTab === "2" && <MyItems />}
        {activeSubTab === "3" && <Basket />}
      </div>
    </div>
  );
}
